/**
 * Constants for custom render components in data grids
 * These components are used in column definitions to specify custom cell rendering
 */

export const RENDER_COUNTRY = 'Country'
